<script setup>

import useSessionActions from '~/composables/sessions/useSessionActions';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);

const { unreserveSeat, isSaveSeatLoading } = useSessionActions(props.session);
const lock = ref(false);

const handleRemoveSavedSeat = async () => {
    if (lock.value) return;
    lock.value = true;

    const { data, pending, error, refresh } = await useAsyncData('unreserveSeat', () => unreserveSeat());
    emit('close');
    lock.value = false;
};

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>"{{ session.title }}" has been removed from your Favorites.</h2>
        <div class="modal-alert">
            <MessSvg class="warning-icon" type="warning" />
            <p>Do you want to remove your saved seat for this session as well?</p>
        </div>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="button" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                :filledIn="true" @click="handleRemoveSavedSeat">
                Yes, remove saved seat
            </ProjectButtonSecondary>
            <ProjectButtonSecondary type="button" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal">
                Don't remove saved seat
            </ProjectButtonSecondary>
        </div>
    </div>
</template>
